const util = {
  /** 日期格式化 */
  formatDate: (date, format) => {
    if (!format) format = 'yyyy-MM-dd'
    if (typeof date === 'string') date = new Date(date)
    const opt = {
      'y+': date.getFullYear().toString(),
      'M+': (date.getMonth() + 1).toString(),
      'd+': date.getDate().toString(),
      'h+': date.getHours().toString(),
      'm+': date.getMinutes().toString(),
      's+': date.getSeconds().toString()
    }
    let ret = ''
    for (const key in opt) {
      ret = new RegExp('(' + key + ')').exec(format)
      if (ret) {
        format = format.replace(ret[1], (ret[1].length === 1) ? (opt[key]) : (opt[key].padStart(ret[1].length, '0')))
      }
    }
    return format
  },
  /** 获取当天日期 */
  getToday: () => {
    return util.formatDate(new Date(), 'yyyy-MM-dd')
  },
  /** 获取最后一天 */
  getLastDate: days => {
    const today = new Date()
    const milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * days
    today.setTime(milliseconds)

    return today
  },
  /** 获取最近几天日期并格式化 */
  getLastFormatDate: days => {
    const today = new Date()
    const milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * days
    today.setTime(milliseconds)

    return util.formatDate(today)
  },
  /** 计算两个日期之间的天数 */
  dateDiff: (startDate, endDate) => {
    startDate = Date.parse(startDate)
    endDate = Date.parse(endDate)
    if (startDate > endDate) return 0
    if (startDate === endDate) return 1
    const days = (endDate - startDate) / (24 * 60 * 60 * 1000)
    return days + 1
  },
  /** 清理数组 */
  cleanArray: (actual) => {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
      if (actual[i]) newArray.push(actual[i])
    }
    return newArray
  },
  /** url参数转json对象 */
  urlParam2Json: (url) => {
    const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
    if (!search) return {}

    const obj = {}
    const searchArr = search.split('&')
    searchArr.forEach(v => {
      const index = v.indexOf('=')
      if (index !== -1) {
        const name = v.substring(0, index)
        const val = v.substring(index + 1, v.length)
        obj[name] = val
      }
    })
    return obj
  },
  /** json对象转url参数 */
  json2UrlParam: (json) => {
    if (!json) return ''
    return util.cleanArray(
      Object.keys(json).map(key => {
        if (json[key] === undefined || json[key] === null || json[key] === '') return ''
        return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`
      })
    ).join('&')
  },
  /** 格式化数字 */
  formatNumber: (number, decimals, formatType = ',') => {
    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    const n = !isFinite(+number) ? 0 : +number
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    const toFixedFix = (n, prec) => {
      const k = Math.pow(10, prec)
      return '' + Math.ceil(n * k) / k
    }
    const ret = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (formatType) {
      const re = /(-?\d+)(\d{3})/
      while (re.test(ret[0])) {
        ret[0] = ret[0].replace(re, '$1,$2')
      }
    }
    if ((ret[1] || '').length < prec) {
      ret[1] = ret[1] || ''
      ret[1] += new Array(prec - ret[1].length + 1).join('0')
    }
    return ret.join('.')
  },
  /** 获取url指定参数 */
  getQueryObject: url => {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
      const name = decodeURIComponent($1)
      let val = decodeURIComponent($2)
      val = String(val)
      obj[name] = val
      return rs
    })
    return obj
  },
  /** 对象合并 */
  objectMerge: (target, source) => {
    if (typeof target !== 'object') target = {}

    if (Array.isArray(source)) return source.slice()

    Object.keys(source).forEach(property => {
      const sourceProperty = source[property]
      if (typeof sourceProperty === 'object') {
        target[property] = util.objectMerge(target[property], sourceProperty)
      } else {
        target[property] = sourceProperty
      }
    })
    return target
  },
  debounce: (func, wait, immediate) => {
    let timeout, args, context, timestamp, result

    const later = function() {
      // 据上一次触发时间间隔
      const last = +new Date() - timestamp

      // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
      if (last < wait && last > 0) {
        timeout = setTimeout(later, wait - last)
      } else {
        timeout = null
        // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
        if (!immediate) {
          result = func.apply(context, args)
          if (!timeout) context = args = null
        }
      }
    }

    return function(...args) {
      context = this
      timestamp = +new Date()
      const callNow = immediate && !timeout
      // 如果延时不存在，重新设定延时
      if (!timeout) timeout = setTimeout(later, wait)
      if (callNow) {
        result = func.apply(context, args)
        context = args = null
      }

      return result
    }
  },
  /** 克隆对象 */
  deepClone: source => {
    if (!source && typeof source !== 'object') {
      throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = util.deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  },
  delay: (duration = 1000) => {
    return new Promise(resolve => setTimeout(resolve, duration || 1000))
  },
  getElementsByType: (htmlString, tagName) => {
    const parser = new DOMParser()
    const html = parser.parseFromString(htmlString, 'text/html')
    const elements = html.getElementsByTagName(tagName)
    // return Array.from(elements).map(item => item.outerHTML)
    return Array.from(elements)
  },
  recursiveToTree: (data = [], rootId = '',  parentKey = 'parentId', idKey = 'id', childrenKey = 'children') => {
    // 按 parentKey 分组
    const grouped = Map.groupBy(data, item => item[parentKey])

    // 递归构建子树
    const buildTree = (parentId) => {
      return (grouped.get(parentId) || []).map(item => {
        const children = buildTree(item[idKey])
        if (children && children.length) return { ...item, [childrenKey]: children }
        else return { ...item }
      })
    }

    return buildTree(rootId)
  }
}

export default util
